// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-toca{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 90px;
    height: 90px;
    margin-left: 280px;
    margin-top: 150px;
    border-radius: 5px;
}

.card-menu{
    margin-left: 90px;
}

.card-fitur{
    width: 440px;
    /* margin-left: -190px; */
    margin-top: 40px;
    background-color: #176B87;
    opacity: 0.85;
    border-radius: 10px;
    height: 145px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  
}

.card-fitur2{
    width: 440px;
    /* margin-left: -190px; */
    margin-top: 22px;
    background-color: #CB0A38;
    opacity: 0.85;
    border-radius: 10px;
    height: 145px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  
}

.card-fitur3{
    width: 440px;
    /* margin-left: -190px; */
    margin-top: 22px;
    background-color: #ECD936;
    opacity: 0.85;
    border-radius: 10px;
    height: 145px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  
}


.card-Assessment{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 90px;
    height: 90px;
    /* margin-left: 110px; */
    margin-top: -25px;
    border-radius: 5px;
}

.card-profile{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 90px;
    height: 90px;
    /* margin-left: 190px; */
    margin-top: -25px;
    border-radius: 5px;
}

.card-myprofile{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 90px;
    height: 90px;
    /* margin-left: 110px; */
    margin-top: -25px;
    border-radius: 5px;
}

.people{
    color: #457777;
    width: 60px !important;
    height: 50px !important;
    /* margin-left: 10px; */
}


.logo-menu{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    /* margin-top: 10%; */
    margin-bottom: 0;

}

.toca-logo-menu{
    width: 13%;
    align-items: center;
    margin-top: 7%;
}

.text-toca {
    display: inline-block;
    vertical-align: top;
    margin-top: 5%;
    margin-left: 3%;
  }
.text-welcome{   
    /* color: #176B87; */
    color: #fff;
    font-weight: 900 !important;
    font-family: 'Poppins' !important;
    font-size: 25px !important;
    margin-top: 7%;
}

.score{
    margin-top: 20px;
}


.btn-chart{
    margin-top: 3%;
    background-color:#018A46;
    color: #fff;
    border:none; 
    border-radius:5px; 
    padding:2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height:80%; 
    width: 90%;
    font-weight: bold;
    align-items: center;
}

.btn-assessor{
    margin-top: 7% ;
    background-color:#E31B1E;
    color: #fff;
    border:none; 
    border-radius:5px; 
    padding:2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height:80%; 
    width: 90%;
    font-weight: bold;
    align-items: center !important

}

.btn-feedback{
    margin-top: 7%;
    background-color:#FEB800;
    color: #fff;
    border:none; 
    border-radius:5px; 
    padding:2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height:80%; 
    width: 90%;
    font-weight: bold;
}

.btn-mandatory{
    margin-top: 7%;
    background-color:#08BEEC;
    color: #fff;
    border:none; 
    border-radius:5px; 
    padding:2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height:80%; 
    width: 90%;
    font-weight: bold;
}

.back-icon-dashboard{
    margin-top: 5px;
    margin-left: -45%;
    display:inline-block;
    color: #fff;
    font-size: 1900;
    position: absolute;
    margin-bottom: 4%;
}

.button-content {
    display: flex;
    align-items: start;
    font-size: xx-large;
  }

.chart-text {
    flex: 1 1; 
    text-align: start; 
    margin-top: 9%;
    font-size: 61%;
    font-weight: bold;
    align-items: left;
    margin-left: 2%;
}

.grafik{
    font-size: 100px !important;
    font-weight: bold;
    color: white;
}


@media (max-width: 768px) {
    .logo-menu{
        flex-direction: column;
    }
  }

  .img-ykbut1{
    width: 100%; 
    height: 100%;
    position: fixed;
    background-position: center;
    margin-top: -0% !important;
  }

  @media (max-width: 767px) {
    .img-ykbut1 {
        height: 100vh; /* Allow the height to adjust for smaller screens */
    }
}

/* Responsive styles for iPad landscape */
@media (min-width: 768px) and (max-width: 1024px) {
    .img-ykbut1 {
        height: 100vh; /* Adjust as needed for iPad landscape */
    }
}

@media (max-width: 767px) {
    .back-icon-dashboard {
        
        margin-left: -40%; /* Adjust margin-left for smaller screens */
        font-size: 14px; /* Adjust font size for smaller screens */
      /* Adjust margin-bottom for smaller screens */
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uCAAuC;;AAE3C;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uCAAuC;;AAE3C;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uCAAuC;;AAE3C;;;AAGA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;AACF;IACI,oBAAoB;IACpB,WAAW;IACX,2BAA2B;IAC3B,iCAAiC;IACjC,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB;;AAEJ;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;IACI,SAAO;IACP,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;AAChB;;;AAGA;IACI;QACI,sBAAsB;IAC1B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE;QACI,aAAa,EAAE,mDAAmD;IACtE;AACJ;;AAEA,yCAAyC;AACzC;IACI;QACI,aAAa,EAAE,wCAAwC;IAC3D;AACJ;;AAEA;IACI;;QAEI,iBAAiB,EAAE,2CAA2C;QAC9D,eAAe,EAAE,yCAAyC;MAC5D,6CAA6C;IAC/C;AACJ","sourcesContent":[".card-toca{\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    transition: 0.3s;\n    width: 90px;\n    height: 90px;\n    margin-left: 280px;\n    margin-top: 150px;\n    border-radius: 5px;\n}\n\n.card-menu{\n    margin-left: 90px;\n}\n\n.card-fitur{\n    width: 440px;\n    /* margin-left: -190px; */\n    margin-top: 40px;\n    background-color: #176B87;\n    opacity: 0.85;\n    border-radius: 10px;\n    height: 145px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  \n}\n\n.card-fitur2{\n    width: 440px;\n    /* margin-left: -190px; */\n    margin-top: 22px;\n    background-color: #CB0A38;\n    opacity: 0.85;\n    border-radius: 10px;\n    height: 145px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  \n}\n\n.card-fitur3{\n    width: 440px;\n    /* margin-left: -190px; */\n    margin-top: 22px;\n    background-color: #ECD936;\n    opacity: 0.85;\n    border-radius: 10px;\n    height: 145px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  \n}\n\n\n.card-Assessment{\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    transition: 0.3s;\n    width: 90px;\n    height: 90px;\n    /* margin-left: 110px; */\n    margin-top: -25px;\n    border-radius: 5px;\n}\n\n.card-profile{\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    transition: 0.3s;\n    width: 90px;\n    height: 90px;\n    /* margin-left: 190px; */\n    margin-top: -25px;\n    border-radius: 5px;\n}\n\n.card-myprofile{\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    transition: 0.3s;\n    width: 90px;\n    height: 90px;\n    /* margin-left: 110px; */\n    margin-top: -25px;\n    border-radius: 5px;\n}\n\n.people{\n    color: #457777;\n    width: 60px !important;\n    height: 50px !important;\n    /* margin-left: 10px; */\n}\n\n\n.logo-menu{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n    /* margin-top: 10%; */\n    margin-bottom: 0;\n\n}\n\n.toca-logo-menu{\n    width: 13%;\n    align-items: center;\n    margin-top: 7%;\n}\n\n.text-toca {\n    display: inline-block;\n    vertical-align: top;\n    margin-top: 5%;\n    margin-left: 3%;\n  }\n.text-welcome{   \n    /* color: #176B87; */\n    color: #fff;\n    font-weight: 900 !important;\n    font-family: 'Poppins' !important;\n    font-size: 25px !important;\n    margin-top: 7%;\n}\n\n.score{\n    margin-top: 20px;\n}\n\n\n.btn-chart{\n    margin-top: 3%;\n    background-color:#018A46;\n    color: #fff;\n    border:none; \n    border-radius:5px; \n    padding:2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height:80%; \n    width: 90%;\n    font-weight: bold;\n    align-items: center;\n}\n\n.btn-assessor{\n    margin-top: 7% ;\n    background-color:#E31B1E;\n    color: #fff;\n    border:none; \n    border-radius:5px; \n    padding:2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height:80%; \n    width: 90%;\n    font-weight: bold;\n    align-items: center !important\n\n}\n\n.btn-feedback{\n    margin-top: 7%;\n    background-color:#FEB800;\n    color: #fff;\n    border:none; \n    border-radius:5px; \n    padding:2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height:80%; \n    width: 90%;\n    font-weight: bold;\n}\n\n.btn-mandatory{\n    margin-top: 7%;\n    background-color:#08BEEC;\n    color: #fff;\n    border:none; \n    border-radius:5px; \n    padding:2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height:80%; \n    width: 90%;\n    font-weight: bold;\n}\n\n.back-icon-dashboard{\n    margin-top: 5px;\n    margin-left: -45%;\n    display:inline-block;\n    color: #fff;\n    font-size: 1900;\n    position: absolute;\n    margin-bottom: 4%;\n}\n\n.button-content {\n    display: flex;\n    align-items: start;\n    font-size: xx-large;\n  }\n\n.chart-text {\n    flex: 1; \n    text-align: start; \n    margin-top: 9%;\n    font-size: 61%;\n    font-weight: bold;\n    align-items: left;\n    margin-left: 2%;\n}\n\n.grafik{\n    font-size: 100px !important;\n    font-weight: bold;\n    color: white;\n}\n\n\n@media (max-width: 768px) {\n    .logo-menu{\n        flex-direction: column;\n    }\n  }\n\n  .img-ykbut1{\n    width: 100%; \n    height: 100%;\n    position: fixed;\n    background-position: center;\n    margin-top: -0% !important;\n  }\n\n  @media (max-width: 767px) {\n    .img-ykbut1 {\n        height: 100vh; /* Allow the height to adjust for smaller screens */\n    }\n}\n\n/* Responsive styles for iPad landscape */\n@media (min-width: 768px) and (max-width: 1024px) {\n    .img-ykbut1 {\n        height: 100vh; /* Adjust as needed for iPad landscape */\n    }\n}\n\n@media (max-width: 767px) {\n    .back-icon-dashboard {\n        \n        margin-left: -40%; /* Adjust margin-left for smaller screens */\n        font-size: 14px; /* Adjust font size for smaller screens */\n      /* Adjust margin-bottom for smaller screens */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
